import { render, staticRenderFns } from "./ApprovalHistory.vue?vue&type=template&id=09d31d9b"
import script from "./ApprovalHistory.vue?vue&type=script&lang=js"
export * from "./ApprovalHistory.vue?vue&type=script&lang=js"
import style0 from "./ApprovalHistory.vue?vue&type=style&index=0&id=09d31d9b&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports